import { ref, inject, computed, defineComponent, useContext, useCssModule } from '@nuxtjs/composition-api';
import { useTask } from 'vue-concurrency';
import { createGridChunks, getArticlesSize } from '~/composables';
import { useDuck } from '~/services';
import { CLUB_PROMO } from '~/pages/club/data';
export default defineComponent({
    name: 'ProfileAuthor',
    props: {
        columns: {
            default: () => ({}),
            type: Object,
        },
        isDone: {
            type: Boolean,
        },
        pageOffset: {
            default: 0,
            type: Number,
        },
        presets: {
            default: () => [],
            type: Array,
        },
    },
    emits: ['setDone'],
    setup(props, { emit }) {
        const profile = inject('profile');
        const articles = ref(profile.value.articles || []);
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        /**
         * Context.
         */
        const context = useContext();
        /**
         * Context.
         */
        const duck = useDuck();
        /**
         * Viewport.
         */
        const viewport = context.$viewport;
        /**
         * Current preset.
         */
        const articlesCards = computed(() => getArticlesSize(viewport.breakpoint, {
            columns: props.columns,
            presets: props.presets,
        }));
        /**
         * Grids.
         */
        const grids = computed(() => createGridChunks(articles.value, articlesCards.value));
        const isFaceClubProfile = profile.value.profile_type === 'face_club';
        /**
         * Fetch articles task.
         */
        const fetchArticlesTask = useTask(function* (signal) {
            if (fetchArticlesTask.isRunning || props.isDone) {
                return;
            }
            signal.addEventListener('abort', () => duck.abortRequest('getPubArticles'));
            try {
                const { data } = yield duck.pub.getPubArticleByAlias({
                    url_alias: profile.value.url_alias,
                    'list[limit]': articlesCards.value,
                    'list[offset]': String(articles.value.length * (props.pageOffset + 1)),
                }, {
                    cancelToken: 'getPubArticleByAlias',
                });
                const newArticles = data.articles || [];
                if (newArticles.length < articlesCards.value) {
                    emit('setDone', true);
                }
                if (!newArticles.length) {
                    return;
                }
                articles.value = [...articles.value, ...newArticles];
            }
            catch (error) {
                console.error(error);
                emit('setDone', true);
            }
        });
        function handleGridIntersect(gridKey) {
            gridKey = gridKey + 1 + props.pageOffset;
            history.replaceState(null, '', gridKey > 1 ? `?page=${gridKey}` : context.route.value.path);
        }
        return {
            articles,
            articlesCards,
            css,
            fetchArticlesTask,
            grids,
            handleGridIntersect,
            profile,
            isFaceClubProfile,
            CLUB_PROMO,
        };
    },
});
